/**
 * Auth utilities - shared localStorage access helpers
 */

const TOKEN_KEY = process.env.REACT_APP_AUTH_TOKEN_KEY || "auth_token";
const REFRESH_TOKEN_KEY = process.env.REACT_APP_REFRESH_TOKEN_KEY || "refresh_token";

const SESSION_KEYS = [
  TOKEN_KEY, REFRESH_TOKEN_KEY, "authenticated", "login", "Name",
  "profileURL", "user_id", "user_email", "user_type", "partner_uuid",
  "country_id", "can_access_admin", "user_data"
];

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const clearSession = () => SESSION_KEYS.forEach(key => localStorage.removeItem(key));

export const getCurrentUserPartnerUuid = () => {
  try {
    const userData = localStorage.getItem("user_data");
    if (userData) return JSON.parse(userData).partnerUuid || null;
  } catch {}
  return null;
};

export const isCurrentUserAdmin = () => {
  try {
    const userData = localStorage.getItem("user_data");
    if (userData) return JSON.parse(userData).userType === "ADMIN";
  } catch {}
  return false;
};

export const getCurrentUserType = () => {
  try {
    const userData = localStorage.getItem("user_data");
    if (userData) return JSON.parse(userData).userType || null;
  } catch {}
  return localStorage.getItem("user_type") || null;
};
